import { Dialog } from '@/components/custom/dialog'
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer'
import { useIsMobile } from '@/hooks'

interface ResponsiveModalProps {
  open?: boolean
  onClose?: () => void
  trigger?: React.ReactNode
  title?: string
  description?: string
  children: React.ReactNode
  contentClassName?: string
  drawerContentClassName?: string
  direction?: 'left' | 'right'
}

export function Modal({
  open,
  onClose,
  trigger,
  title,
  description,
  children,
  contentClassName,
  drawerContentClassName,
  direction,
}: ResponsiveModalProps) {
  const isMobile = useIsMobile()

  if (isMobile) {
    return (
      <Drawer
        open={open}
        onOpenChange={(isOpen) => !isOpen && onClose?.()}
        direction={direction}
      >
        {trigger && <DrawerTrigger asChild>{trigger}</DrawerTrigger>}
        <DrawerContent className={`${contentClassName ?? ''} ${drawerContentClassName ?? ''}`.trim()}>
          <DrawerHeader className="shrink-0">
            {title && <DrawerTitle>{title}</DrawerTitle>}
            <DrawerDescription className="sr-only">
              {description || 'modal content'}
            </DrawerDescription>
          </DrawerHeader>
          <div
            className="min-h-0 flex-1 overflow-y-auto px-4 [&::-webkit-scrollbar]:hidden [scrollbar-width:none]"
            style={{ paddingBottom: 'max(2rem, env(safe-area-inset-bottom))' }}
          >
            {children}
          </div>
        </DrawerContent>
      </Drawer>
    )
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      trigger={trigger}
      title={title}
      description={description}
      contentClassName={contentClassName}
    >
      {children}
    </Dialog>
  )
}
